export default "__VITE_PUBLIC_ASSET__634366f7__"